import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { DatePicker, Button, Input, Layout, Row, Col, Select, Icon } from 'antd'
import moment from 'moment'
import { couponStatus } from '@texts/coupons'
@inject((store: any) => {
    const { couponTypesStore, couponsStore } = store
    return { couponTypesStore, couponsStore }
})
@observer
export default class FilterCoupons extends Component<any, any> {
    state = {
        display: false
    }
    handleFilter = (name, value) => {
        const { addFilter, getList } = this.props.couponsStore
        addFilter('page', 1)
        addFilter(name, value)
        getList()
    }
    toggleDisplay = () => {
        this.setState(prevState => ({ display: !prevState.display }))
    }
    render() {
        const {
            couponsStore: { filters, pagination }
        } = this.props
        const { display } = this.state
        return (
            <Layout style={{ backgroundColor: 'rgb(250 250 250)', padding: '0.5rem 1rem 0', marginBottom: '0rem' }}>
                <Row style={{ cursor: 'pointer' }} onClick={this.toggleDisplay}>
                    <Col>
                        <strong style={{ fontSize: '1rem', margin: '0' }}>
                            <Icon type={display ? 'arrow-down' : 'arrow-left'} />
                            סינון תוצאות (נמצאו {pagination.total} קופונים)
                        </strong>
                    </Col>
                </Row>
                {display && (
                    <Row gutter={10}>
                        <Col xs={8}>
                            <label>
                                <strong>טעינת קופון</strong>
                            </label>
                            <Input
                                type="number"
                                placeholder="הזן טעינה לשימוש"
                                min={1}
                                max={10000}
                                onChange={e => this.handleFilter('load', e.target.value)}
                                value={filters['load']}
                            />
                        </Col>
                        <Col xs={8}>
                            <label>
                                <strong>תוקף קופון</strong>
                            </label>
                            <DatePicker
                                style={{ width: '100%', marginBottom: '0' }}
                                placeholder="תאריך תפוגת הקופון"
                                value={'expiration_date' in filters ? moment(filters['expiration_date']) : null}
                                onChange={(d, m) => {
                                    const date = d ? `${d.format('YYYY-MM-DD')} 23:59:59` : null
                                    this.handleFilter('expiration_date', date)
                                }}
                            />
                        </Col>
                        <Col xs={8}>
                            <label>
                                <strong>מצב הקופון</strong>
                            </label>
                            <Select
                                placeholder="בחר מצב קופון"
                                style={{ width: '100%' }}
                                onChange={e => this.handleFilter('status', e)}
                            >
                                <Select.Option key={'NO_FILTER'} value={undefined}>
                                    ללא סינון
                                </Select.Option>
                                {Object.keys(couponStatus).map(key => (
                                    <Select.Option key={key} value={key}>
                                        {couponStatus[key]}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Col>
                    </Row>
                )}
            </Layout>
        )
    }
}
